import { InputType } from '@empathy/survey/base';

export const InputTypeLabels: Record<InputType, string> = {
  [InputType.Email]: 'Email',
  [InputType.Numbers]: 'Numbers',
  [InputType.Phone]: 'Phone',
  [InputType.Text]: 'Text'
};
